import DTSTAMP from './DTSTAMP'

/**
 * LAST_MODIFIED property.
 *
 * @see https://tools.ietf.org/html/rfc5545#section-3.8.7.3
 */
export class LAST_MODIFIED extends DTSTAMP {
  static propName = 'LAST-MODIFIED'
}



// WEBPACK FOOTER //
// ./src/properties/LAST_MODIFIED.js